const routes = [
    {
        path: "/student/club/member/search",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentclubstudent_index"
        }
    }
];

export default routes;
